import bodyLock from "../utils/body-lock";
import { currencySwitcher } from "../utils/currency-switcher";

class CurrencySwitcherFooter extends HTMLElement {
  constructor() {
    super();

    const currencySwitcherFooterElement = this;
    const textInput = currencySwitcherFooterElement.querySelector(
      ".currency-search-input--mobile"
    );
    const currencySlector =
      currencySwitcherFooterElement.querySelector(".current-currency");
    const currencyForm =
      currencySwitcherFooterElement.querySelector(".currency-form");
    const closeCurrencyForm =
      currencySwitcherFooterElement.querySelector(".close-button");
    const currencySelctor =
      currencySwitcherFooterElement.querySelector(".currency");

    textInput?.addEventListener("input", (e) => {
      currencySwitcher(e.target.value.charAt(0).toUpperCase() + e.target.value.slice(1));
    });

    closeCurrencyForm?.addEventListener("click", () => {
      currencyForm.classList.remove("currency-form--js-active");
      bodyLock.unlock();
      textInput.value = " ";
      currencySwitcher(" ");
    });

    currencySlector?.addEventListener("click", () => {
      // Trigger for opening currency form online on mobile size
      if (window.innerWidth < 768) {
        currencyForm?.classList.add("currency-form--js-active");
        bodyLock.lock();
      }
    });

    // Trigger for opening currency form from mobile menu

    const currencySwitcherMobile = document.querySelector(
      ".mobile-currency-trigger-menu"
    );

    currencySwitcherMobile.addEventListener("click", () => {
      currencyForm.classList.add("currency-form--js-active");
      bodyLock.lock();
    });
  }
}

if (customElements.get("currency-switcher-footer") === undefined) {
  customElements.define("currency-switcher-footer", CurrencySwitcherFooter);
}
